import React, { useEffect, useState } from "react"
// import Modal from 'react-modal';
import { Link } from "react-router-dom";
import Slidewithindicator from "./slidewithindicator"
import ReactBSAlert from "react-bootstrap-sweetalert";
import { apiEndpoint } from "helpers/url_helper";


import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap"


const ViewImageModalComponent = (props) => {
    console.log("props data:", props);
  const [violationImageIndex, setViolationImageIndex] = useState(0);
    useEffect(() => {
        
    
    // UserValidated
  fetch(apiEndpoint+"//GetViolationLogImages",
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          "RecordID": props.RecordID,
        "strToken": sessionStorage.getItem("Clear_AuthUser")
      })
    })
    .then(res => res.json())
            .then(
                (result) => {
                    debugger;
                if (result != undefined || result != "") {
                  //console.log(result);
                  if (result.Message == "File not found!") {
                    console.log("No Image found!!");
                    setAlert (
                      <ReactBSAlert
                        warning
                      //   style={bsAlertStyle}
                      //   title="Good job!"
                        onConfirm={() => setAlert(null)}
                        onCancel={() => setAlert(null)}
                        confirmBtnBsStyle="warning"
                      >
                        {result.Message}
                      </ReactBSAlert>
                    )
                  }
                  else {
                    setImageData(result);
                  }

                }
                else {
                  console.log("No Image found!!");
                }
              },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //console.log(error);
                    // /setError(error);
                }
            )
    }, [props.ImgPath])

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [imgData, setImageData] = useState();
  const [alertmsg, setAlert] = useState();
  const toggle = () => {
    
    setModalIsOpen(!modalIsOpen)
  }
  return (
    <>
      {/* <button onClick={setModalIsOpenToTrue}>View</button> */}
      <Link to='#'
      onClick={toggle}><i className=" mdi mdi-eye mdi-24px"></i></Link>
        {modalIsOpen==true && alertmsg}
{imgData!=undefined &&
      <Modal isOpen={modalIsOpen} style={{ maxWidth: "60%" }}>

        {/* <img src={testimage} alt="" height="400" width="100%" /> */}
        <ModalHeader toggle={toggle} tag="h4">
         {/* {imgName} */}
        </ModalHeader>
        <ModalBody>
          <Slidewithindicator ImagePath={imgData} ImageIndex={setViolationImageIndex}/>
          {/* <img width="100%" height="400px" src={"data:image/png;base64," +imgName}/> */}
        </ModalBody>

      </Modal>
}
    </>
  )
}
export default ViewImageModalComponent;